// extracted by mini-css-extract-plugin
export default {"avatarWithMainInfo":"RQl_W0ufYOdwceb9SLjO","avatar":"jEff2NpTIPz80hzbQ_8l","info":"yOnR1ANLspayHbXUnczf"};